const HeroBanner = () => {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      className="relative w-full h-[580px] md:h-[680px] flex items-center overflow-hidden"
    >
      {/* Background Image */}
      <img
        src="https://public.readdy.ai/ai/img_res/f8e9a09508c4ad96633bc252de0e2fa8.jpg"
        alt="신선한 과일 배경"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/40 to-black/20"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 pt-16 md:pt-0 flex flex-col lg:flex-row items-center gap-10">
        {/* Left Text */}
        <div className="flex-1 text-white">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-4">
            자연이 주는<br />
            <span className="text-green-400">달콤한 선물</span><br />
            프리미엄 과일
          </h1>
          <p className="text-white/80 text-base md:text-lg mb-8 max-w-md leading-relaxed">
            산지 직송으로 더 신선하게, 엄선된 최고 품질의 과일을<br className="hidden md:block" />
            합리적인 가격에 만나보세요.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={() => handleScroll('#categories')}
              className="bg-green-500 hover:bg-green-600 text-white font-semibold px-7 py-3.5 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-shopping-basket-line"></i>
              지금 주문하기
            </button>
            <button
              onClick={() => handleScroll('#categories')}
              className="border-2 border-white/70 hover:border-white text-white font-semibold px-7 py-3.5 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
            >
              과일 둘러보기
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>

          {/* Stats */}
          <div className="flex gap-8 mt-10">
            {[
              { value: '500+', label: '과일 품종' },
              { value: '98%', label: '고객 만족도' },
              { value: '당일', label: '산지 직송' },
            ].map((stat) => (
              <div key={stat.label}>
                <div className="text-2xl font-extrabold text-green-400">{stat.value}</div>
                <div className="text-white/70 text-xs mt-0.5">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 text-white/60 animate-bounce">
        <i className="ri-arrow-down-line text-lg"></i>
      </div>
    </section>
  );
};

export default HeroBanner;
